import { buildEdgeFunctionUrl, getEnvironmentConfig } from '@/lib/environment';

export const triggerDocumentProcessing = async (
  documentId: string,
  clerkToken: string
): Promise<void> => {
  const config = getEnvironmentConfig();
  const url = `${buildEdgeFunctionUrl('stella-api', '/files/embed')}?documentId=${documentId}`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${clerkToken}`,
      apikey: config.supabasePublishableKey,
    },
  });

  if (!response.ok) {
    const error = await response
      .json()
      .catch(() => ({ error: 'Unknown error' }));
    throw new Error(
      `Processing trigger failed: ${error.error || response.statusText}`
    );
  }

  console.log(`Document processing triggered successfully for ${documentId}`);
};
